import { render } from "./ChatRoomUserManager.vue?vue&type=template&id=373d426c"
import script from "./ChatRoomUserManager.vue?vue&type=script&lang=js"
export * from "./ChatRoomUserManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__